import { render, staticRenderFns } from "./EditText.vue?vue&type=template&id=31e80e08&scoped=true&"
import script from "./EditText.vue?vue&type=script&lang=js&"
export * from "./EditText.vue?vue&type=script&lang=js&"
import style0 from "./EditText.vue?vue&type=style&index=0&id=31e80e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e80e08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
